import * as React from 'react'
import type {OmitStrict} from 'type-zoo'
import {safelyOr} from '@kapitalist/utils/safely'
import type {RequireOptionalKeyPresence} from '@kapitalist/utils/types'
import SettingsCircle from '~/components/SettingsCircle'
import BaseLayout from '~/layouts/BaseLayout'
import {HeaderWordmark} from '~/layouts/components/HeaderWordmark'
import type {
  IPropsGuaranteedBySignedInRoutes,
  ISignedInRouteComponentProps,
} from '~/routing/Route/SignedIn'
import type {ROUTE_TYPE_KEY} from '~/routing/Route/types'
import styles from './styles.module.css'

// both Route.Admin and Route.SignedInRequiresOrg use the dashboard layout right now
// and they both pass the same props, except the ROUTE_TYPE_KEY bit, so accept them both.
// NB: these are manually provided by the page using the DashboardLayout because we don't have a custom `withRouter`
//     for Route.SignedInRequiresOrg / ISignedInRequiredOrgRouteComponentProps
// you can use `isolateSignedInRouteComponentProps` to grab them easily
interface IManuallyProvidedRouteProps extends OmitStrict<
  // a component with potentially any defined path pieces might pass their
  // RouteComponentProps to a layout, and we don't care about those here
  // eslint-disable-next-line @typescript-eslint/no-restricted-types
  ISignedInRouteComponentProps<any>,
  typeof ROUTE_TYPE_KEY
> {}

interface IProps extends IManuallyProvidedRouteProps {
  title?: string
  topRightStuff?: React.ReactNode | React.ReactNode[]
  children: React.ReactNode
}

export default class DashboardLayout extends React.Component<IProps> {
  render() {
    return <LoginAgnosticDashboardLayout {...this.props} />
  }
}

// A version of the DashboardLayout that can handle both when a user is logged in and not logged in.
export class LoginAgnosticDashboardLayout extends React.Component<
  OmitStrict<IProps, keyof IPropsGuaranteedBySignedInRoutes> &
    RequireOptionalKeyPresence<Partial<IPropsGuaranteedBySignedInRoutes>>
> {
  render() {
    return (
      <BaseLayout>
        <div className={styles.topBar}>
          <div className={styles.left}>
            <HeaderWordmark />
          </div>
          <div className={styles.right}>
            {this.props.topRightStuff}
            {safelyOr(
              this.props.authenticatedPlayer,
              ap => (
                <SettingsCircle authenticatedPlayer={ap} />
              ),
              null
            )}
          </div>
        </div>
        <div className={styles.dashboardLayoutFrame}>{this.props.children}</div>
      </BaseLayout>
    )
  }
}
